import type { MGMProductCode } from '@innogy/become-a-customer/shared/interfaces';

export interface MGMBuyerInfo {
  name: string;
  email: string;
  bank_account: string;
  sale_id: string;
  product: MGMProductCode;
  state: 'confirmed';
}

const pageNames = ['sharing', 'thankyou', 'portal'] as const;
export type PageName = (typeof pageNames)[number];
export const isPageName = (name: string): name is PageName =>
  pageNames.some((page) => page === name);

export interface MGMWidgetConfig {
  displayDefaultIntro: boolean;
  environment: 'production' | 'acceptance';
  project: string;
  selector: `#${string}`;
  pagename?: PageName;
  userName?: string;
  userEmail?: string;
}

export interface MGMWindowAdditions {
  MGMCo?: any;
  mgmcoPing?: any;
}
